export function includedInBudget(record: RecordEntry): boolean {
  return !record.excludeFromBudget;
}
